<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      row-id="fabricSeriesCode"
    >
      <!-- :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick" -->
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:displayFabricName="{ row }">
        <TableLabel :value="row.fabricSeriesName" />
        <TableLabel :value="row.fabricSeriesNameEn" />
        <TableLabel label="NO" :value="row.fabricSeriesNo" />
      </template>
      <template v-slot:fabricSeriesStatus="{ row }">
        <div style="display: flex;justify-content: center;">
          <el-tag
            class="mr-2"
            size="mini"
            :type="
              row.fabricSeriesStatus === 'Y'
                ? 'success'
                : row.fabricSeriesStatus === 'N'
                ? 'info'
                : row.fabricSeriesStatus === 'P'
                ? 'primary'
                : row.fabricSeriesStatus === 'R'
                ? 'warning'
                : 'danger'
            "
          >
            {{ row.v_fabricSeriesStatus }}
          </el-tag>
        </div>
        <el-link
          v-if="row.rejectReason && row.fabricSeriesStatus === 'R'"
          type="danger"
          :underline="false"
          style="font-size: 13px;"
          @click="showRejectReason(row)"
        >
          {{ $l('btn_showRejectReason') || '查看驳回原因' }}
        </el-link>
      </template>

      <template v-slot:fabricWeight="{ row }">
        <TableLabel
          :label="$l('table_label_fabricWeight') || '克重'"
          :value="`${row.fabricWeight || 0} ${row.fabricWeightUnit}`"
        />
      </template>
      <template v-slot:displayFabricContent="{ row }">
        <TableLabel :value="row.fabricContent" />
        <TableLabel :value="row.fabricContentEn" />
      </template>

      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>

      <template v-slot:displaySubmitBy="{ row }">
        <span>{{ row.submitByName }}</span>
        <br />
        <span>{{ row.submitDate }}</span>
      </template>
      <template v-slot:displayApprovalBy="{ row }">
        <span>{{ row.approvalByName }}</span>
        <br />
        <span>{{ row.approvalDate }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import TableLabel from './label.vue'
export default {
  components: { TableLabel },
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      const { fabricSeriesCode, fabricSeriesNo } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'changeName':
        case 'addFabric':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { fabricSeriesCode },
            query: { fabricSeriesNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'apply':
          this.$emit('apply', [fabricSeriesCode])
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'defaultImageUrl']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
    del({ fabricSeriesCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.$api.masterFabricSeriesEcomDel({ fabricSeriesCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    showRejectReason({ rejectReason }) {
      this.$alert(
        rejectReason,
        this.$l('INDEX.alert_title_rejectReason') || '驳回原因',
        {
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: this.$l('INDEX.btn_cancel') || '关闭',
        },
      )
    },
  },
}
</script>
